import React, { useState, useEffect, useRef } from "react";
import { ImGift, ImLocation } from "react-icons/im";
import trashicon from "../../assets/assets/images/profile/red_bin.png";
// import { Tooltip as ReactTooltip } from "react-tooltip";
import { useLocation } from "react-router-dom";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  cancelBooking,
  cleanCompleteBookingResponse,
  completeBookingByUser,
  fetchUserBooking,
} from "../../redux/Slice/bookingSlice";
import {
  cleanPostRatingResponse,
  getAllCars,
} from "../../redux/Slice/carSlice";
// import { FaCheckCircle, FaEye } from "react-icons/fa";
// import { BsThreeDotsVertical } from "react-icons/bs";
import { toast } from "react-toastify";
import Rating from "@mui/material/Rating";
import Stack from "@mui/material/Stack";
// import { Tooltip } from "@mui/material";
import SuccessModal from "../RentYourCar/PaymentSuccessModal";
import RatingModal from "./RatingModal";
import CarOwnerDetailsModal from "./CarOwnerDetailsModal";
import { Menu, MenuItem, IconButton, Tooltip } from "@mui/material";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaCheckCircle, FaUser } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { RxDotFilled } from "react-icons/rx";
const BookingCard = ({
  statusChangeHandler,
  index,
  data,
  startDate,
  endDate,
  price,
}) => {
  console.log("data", data);
  const userDetail = useSelector((state) => state?.auth?.userDetail);
  const location = useLocation();
  const dispatch = useDispatch();
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const cancelBookingData = useSelector(
    (state) => state?.booking?.cancelBooking
  );
  const completeBookingResponse = useSelector(
    (state) => state?.booking?.completeBookingResponse
  );
  const userBooking = useSelector((state) => state?.booking?.userBooking);
  let status = "pending";
  const [showDetail, setShowDetail] = useState(false);
  const [cancelIndex, setCancelTargetIndex] = useState(null);
  const postRatingResponse = useSelector(
    (state) => state?.car?.postRatingResponse
  );
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [isCarOwnerModalOpen, setIsCarOwnerModalOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const handleOpenModal = () => setIsCarOwnerModalOpen(true);
  const handleCloseModal = () => setIsCarOwnerModalOpen(false);

  const carOwnerDetailsModal = (data) => {
    handleOpenModal();
  };
  console.log(anchorEl, "anchorEl");
  const [matchingRating, setMatchingRating] = useState([]);

  const [bookingData, setBookingData] = useState(userBooking?.data?.data);
  if (location.pathname === "/mybooking/recent-order") status = "Pending";
  if (location.pathname === "/mybooking/completed-order") status = "Completed";
  if (location.pathname === "/mybooking/cancelled-order") status = "Cancelled";

  useEffect(() => {
    const matchingRatings = data?.car?.ratings.filter(
      (rating) => rating.userId === userDetail?.data?._id
    );
    setMatchingRating(matchingRatings);
    // Formatting the date
  }, [data]);

  const formatDateTime = (dateTimeString) => {
    // Check if the string ends with "GMT"
    if (dateTimeString.endsWith(" GMT")) {
      // Remove " GMT" from the date string
      dateTimeString = dateTimeString.replace(" GMT", "");
    }

    // Convert the date-time string to a Date object
    const dateTime = new Date(dateTimeString);

    const dateOptions = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = dateTime.toLocaleDateString("en-US", dateOptions);

    // Formatting the time
    const timeOptions = {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    };
    const formattedTime = dateTime.toLocaleTimeString("en-US", timeOptions);

    return { date: formattedDate, time: formattedTime };
  };

  // Format start date
  const formattedStartDate = formatDateTime(startDate);
  // Format end date
  const formattedEndDate = formatDateTime(endDate);

  const toggleShow = () => setShowDetail(!showDetail);

  const cancelBookingHandler = (id, index) => {
    dispatch(cancelBooking({ bookingId: id }));

    setCancelTargetIndex(index);
  };

  const bookingSuccessHandler = async (id) => {
    let compResp = await dispatch(completeBookingByUser({ bookingId: id }));
    if (compResp?.payload?.status === 200) {
      toast(compResp?.payload?.data?.message);
      dispatch(fetchUserBooking({ userId: userDetail?.data?._id }));
    }
  };

  const [isFuture, setIsFuture] = useState(true);

  useEffect(() => {
    const checkTime = () => {
      if (data?.status === "Active") {
        const givenTimeUTC = new Date(data?.returnDateandTime);
        const currentTime = new Date();
        if (givenTimeUTC < currentTime) {
          setIsFuture(false);
        } else {
          setIsFuture(true);
        }
      }
      setTimeout(checkTime, 1000); // Schedule the next check in 1 second
    };

    // Initial check
    checkTime();

    // Clean up any pending timeouts on component unmount
    return () => clearTimeout(checkTime);
  }, [data]);

  useEffect(() => {
    if (cancelBookingData?.data?.success) {
      dispatch(fetchUserBooking({ userId: userDetail?.data?._id }));
    }
  }, [cancelBookingData]);

  // useEffect(() => {
  //     if (completeBookingResponse?.success) {
  //         dispatch(fetchUserBooking({ userId: userDetail?.data?._id }))
  //     }

  // }, [completeBookingResponse])

  useEffect(() => {
    if (postRatingResponse?.success) {
      dispatch(fetchUserBooking({ userId: userDetail?.data?._id }));
      dispatch(cleanPostRatingResponse());
    }
  }, [postRatingResponse]);
  return (
    <div className="row">
      <div className="col-12">
        <div
          key={data?._id}
          className="bg-white gap-3 gap-md-0 mb-4 rounded-4 border-0  card shadow"
        >
          <div className="card-body row">
            <div className="col-md-6 col-lg-4 h-100  text-start text-center mb-3 mb-md-0">
              <img
                src={`${baseURL}${data?.car?.frontImage}`}
                className="mybooking-img w-100"
                alt="car"
              />
            </div>

            <div className="col-md-6 col-lg-8 ">
              <div>
                <h3 className="text-capitalize mb-2">
                  {data?.car?.maker?.carMake} - { data?.car?.model?.carModel}
                </h3>
                {data?.car?.withDriver && (
                  <p className=" rounded-5 px-2 red-badge">
                    <RxDotFilled className=" my-auto" />
                    With Driver
                  </p>
                )}
              </div>
              <div className="">
                <div className="d-flex flex-row align-items-center">
                  <p className="m-0 fw-medium font14">Status:</p>
                  <p className="ps-1 text-secondary font14">{data?.status}</p>
                </div>
                <div className="d-flex flex-row align-items-center">
                  <p className="m-0 fw-medium font14">Booking Date:</p>
                  <p className="ps-1 text-secondary font14">
                    {formattedStartDate.date} {formattedStartDate.time}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-column justify-content-between flex-lg-row gap-2">
                {/* <p className='fw-medium' >Pickup Location: </p><p className='text-secondary text-start ms-1' > 2464 Royal Ln. Mesa, New Jersey 45453 </p> */}
                <div className="d-flex flex-column flex-lg-row">
                  <p className="fw-medium font14 ">Pickup Location: </p>
                  <p className="text-secondary text-start ms-1 text-balance font14">
                    {" "}
                    {data?.car?.carLocation}{" "}
                  </p>
                </div>
                {data?.status.toLowerCase() === "complete" ? (
                  <p className="text-end">
                    {matchingRating?.length ? (
                      <Stack spacing={1}>
                        <Rating
                          name="half-rating"
                          value={matchingRating[0]?.rating}
                          readOnly
                          precision={0.5}
                        />
                      </Stack>
                    ) : (
                      <>
                        <button
                          className="fs18 pointor driver-detail-btn  border-0 text-nowrap"
                          onClick={handleOpen}
                        >
                          Rate us
                        </button>
                        <RatingModal
                          isRating={open}
                          isHandleClose={handleClose}
                          carId={data?.car?._id}
                          bookingId={data?._id}
                        />
                      </>
                    )}
                  </p>
                ) : null}
                {/* {
                            data?.car?.ratings[0]?.rating ?
                                <Stack spacing={1}>
                                    <Rating name="half-rating" value={data?.car?.ratings[0]?.rating} readOnly precision={0.5} />
                                </Stack> :
                                <>

                                </>
                        }
                        {data?.status.toLowerCase() === "complete" ? <>
                            <button className='fs18 pointor driver-detail-btn  border-0 ' onClick={handleOpen}>Rate us</button>
                            <RatingModal isRating={open} isHandleClose={handleClose} carId={data?.car?._id} bookingId={data?._id} />
                        </>
                            // <Stack spacing={1}>
                            //     <Tooltip title="Rate us" arrow>
                            //         <Rating name="half-rating" value={0} precision={0.5} />
                            //     </Tooltip>
                            // </Stack> 
                            :
                            null
                        } */}
              </div>
              {/* <div className="mt-3">
                Car Owner Details:
                <div className="d-flex flex-column flex-lg-row my-3 align-items-start align-items-lg-center justify-content-between gap-lg-2">
                  <div className="d-flex flex-row flex-lg-column">
                    <p className="accentColor text_wrap_balance font14">
                      Name:{" "}
                    </p>
                    <p className="text_wrap_balance font14">
                      {data?.car?.user?.name}
                    </p>
                  </div>

                  <div className="d-flex flex-row flex-lg-column">
                    <p className="accentColor text_wrap_balance font14">
                      Phone Number:{" "}
                    </p>
                    <p className="text_wrap_balance font14">
                      {data?.car?.UserPhoneNumber}
                    </p>
                  </div>
                  <div className="d-flex flex-row flex-lg-column justify-content-lg-between">
                    <p className="accentColor text_wrap_balance font14">
                      Email:
                    </p>
                    <p className="text_wrap_balance font14">
                      {data?.car?.UserEmail}
                    </p>
                  </div>
                </div>
              </div> */}

              <div className=" d-flex flex-column flex-lg-row my-3 align-items-start align-items-lg-center  justify-content-between gap-lg-2">
                {/* <div>
            <h3 className="text-capitalize">{data?.car?.maker?.carMake}</h3>
          
          </div> */}
                <div className="d-flex flex-row flex-lg-column">
                  <p className="accentColor text_wrap_balance font14">
                    Trip Start :{" "}
                  </p>
                  <p className="text_wrap_balance font14">
                    {formattedStartDate.date} {formattedStartDate.time}
                  </p>
                </div>
                <div className="d-flex flex-row flex-lg-column">
                  <p className="accentColor text_wrap_balance font14">
                    Trip End :{" "}
                  </p>
                  <p className="text_wrap_balance font14">
                    {formattedEndDate.date} {formattedEndDate.time}
                  </p>
                </div>
                <div className="d-flex flex-row flex-lg-column justify-content-lg-between">
                  <p className="accentColor text_wrap_balance font14">
                    Payment Status :
                  </p>
                  <p className="text_wrap_balance font14">
                    {" "}
                    {data?.paymentStatus}{" "}
                  </p>
                </div>
                <div className="d-flex flex-row flex-lg-column justify-content-lg-between">
                  <p className="accentColor text_wrap_balance font14">
                    Booking Amount :
                  </p>
                  <p className="text_wrap_balance font14">
                    {" "}
                    K{data?.totalAmount}
                  </p>
                </div>

                {/* {(location.pathname === '/mybooking/recent-order' || location.pathname === '/mybooking') && (data?.status.toLowerCase() === "active") ? <img src={trashicon} alt='delete_image' data-tooltip-id="cancel-order" onClick={() => cancelBookingHandler(data?._id, index)} className='trash-icon' /> : null}
                        {(data?.status.toLowerCase() === "active") ? <ReactTooltip
                            id="cancel-order"
                            place="bottom"
                            content="Cancel Order"
                        /> : null} */}
              </div>
              <div
                className={`d-flex align-items-center ${
                  data?.bookWithDriver
                    ? "justify-content-between"
                    : "justify-content-end"
                  // data?.car?.withDriver
                  //   ? "justify-content-between"
                  //   : "justify-content-end"
                }`}
              >
                {/* {data?.car?.withDriver ? ( */}
                {/* {data?.bookWithDriver ? (
                  <p
                    className=" pointor driver-detail-btn"
                    onClick={toggleShow}
                  >
                    Driver's details
                    {showDetail ? (
                      <MdOutlineKeyboardArrowUp className="fs-4 primaryColor" />
                    ) : (
                      <MdOutlineKeyboardArrowDown className="fs-4 primaryColor" />
                    )}
                  </p>
                ) : null} */}
                {/* <div className="dropdown dropdown-new d-flex justify-content-center">
                  {data?.status.toLowerCase() === "active" ? (
                    <button
                      type="button"
                      className="btn px-2 dropdown-action bg-drop px-0 border-0 "
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <BsThreeDotsVertical />
                    </button>
                  ) : null}
                  <ul className="dropdown-menu dropdown-menu-width dropdown-menu-end py-2">
                  <li
                          onClick={() =>carOwnerDetailsModal(data)}
                          className="text-center mb-2 pointor"
                        >
                          <FaCheckCircle className="edit-icon-fav fs-5 text-dark" />
                          <span className="px-1">Owner Details</span>
                        </li>
                    {data?.status.toLowerCase() === "active" ? (
                      <>
                        <li
                          onClick={() => bookingSuccessHandler(data?._id)}
                          className="text-center mb-2 pointor"
                        >
                          <FaCheckCircle className="edit-icon-fav fs-5 text-dark" />
                          <span className="px-1">Complete</span>
                        </li>
                      </>
                    ) : null}
                    <li className="text-center">
                      {(location.pathname === "/mybooking/recent-order" ||
                        location.pathname === "/mybooking") &&
                      data?.status.toLowerCase() === "active" ? (
                        isFuture ? (
                          <span
                            onClick={() =>
                              cancelBookingHandler(data?._id, index)
                            }
                            className="pointor"
                          >
                            <img
                              src={trashicon}
                              alt="delete_image"
                              data-tooltip-id="cancel-order"
                              className="booking-trash"
                            />{" "}
                            <span className="px-1">Cancel</span>
                          </span>
                        ) : null
                      ) : null}
                      {data?.status.toLowerCase() === "active" ? (
                        <ReactTooltip
                          style={{
                            backgroundColor: "#008080cc",
                            zIndex: "999",
                          }}
                          id="cancel-order"
                          place="bottom"
                          content="Cancel Order"
                        />
                      ) : null}
                    </li>
                   
                  </ul>
                </div> */}
                <div className="d-flex justify-content-center">
                  {/* Three-Dots Button */}
                  {/* {data?.status.toLowerCase() === "active" && (
                    <IconButton onClick={handleMenuOpen}>
                      <BsThreeDotsVertical />
                    </IconButton>
                  )} */}
                  <IconButton onClick={handleMenuOpen}>
                    <BsThreeDotsVertical />
                  </IconButton>

                  {/* Dropdown Menu */}
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    // PaperProps={{
                    //   style: { width: "200px" }, // Set the width of the menu
                    // }}
                  >
                    {/* Owner Details */}
                    <MenuItem
                      onClick={() => {
                        carOwnerDetailsModal(data);
                        handleMenuClose();
                      }}
                    >
                      <FaUser className="edit-icon-fav text-dark" />
                      <span style={{ marginLeft: "8px" }}>Owner Details</span>
                    </MenuItem>

                    {/* Complete */}
                    {data?.status.toLowerCase() === "active" && (
                      <MenuItem
                        onClick={() => {
                          bookingSuccessHandler(data?._id);
                          handleMenuClose();
                        }}
                      >
                        <FaCheckCircle className="edit-icon-fav text-dark" />
                        <span style={{ marginLeft: "8px" }}>Complete</span>
                      </MenuItem>
                    )}

                    {/* Cancel */}
                    {(location.pathname === "/mybooking/recent-order" ||
                      location.pathname === "/mybooking") &&
                    data?.status.toLowerCase() === "active" &&
                    isFuture ? (
                      <Tooltip title="Cancel Order" placement="right" arrow>
                        <MenuItem
                          onClick={() => {
                            cancelBookingHandler(data?._id, index);
                            handleMenuClose();
                          }}
                        >
                          <MdCancel style={{ color: "red" }} />
                          <span style={{ marginLeft: "8px" }}>Cancel</span>
                        </MenuItem>
                      </Tooltip>
                    ) : null}
                  </Menu>
                </div>
              </div>
              {showDetail ? (
                <div
                  className="d-flex justify-content-between mt-2 flex-column flex-lg-row"
                  // className={
                  //   showDetail
                  //     ? "visibility driver-detail showDetail mt-2"
                  //     : "showDetail-not invisibility driver-detail mt-2"
                  // }
                >
                  {/* <div><span className='accentColor' >Id:</span> TG4567</div> */}
                  <div className="align-items-center d-flex flex-wrap gap-1 ">
                    <span className="accentColor mobile-font14">Name:</span>{" "}
                    {""}
                    <span className="text-capitalize mobile-font14">
                      {data?.car?.driver?.name}
                    </span>
                  </div>
                  <div className="align-items-center d-flex flex-wrap gap-1">
                    <span className="accentColor mobile-font14">Age:</span>{" "}
                    <span className="mobile-font14">
                      {data?.car?.driver?.age}
                    </span>
                  </div>
                  <div className="align-items-center d-flex flex-wrap gap-1">
                    <span className="accentColor mobile-font14">Mobile:</span>{" "}
                    <span className="mobile-font14">
                      {" "}
                      {/* {data?.car?.driver?.phoneNumber} */}
                      {data?.car?.driver?.phoneNumber &&
                        (data?.car?.driver?.driver_country_code
                          ? `${data.car.driver.driver_country_code} ${data.car.driver.phoneNumber}`
                          : data.car.driver.phoneNumber)}
                    </span>
                  </div>
                  {/* <div><span className='accentColor' >Liscense No:</span>XXXXXXX</div> */}
                </div>
              ) : null}
            </div>
          </div>

          {/* mobile view  */}

          {/* {(location.pathname === '/mybooking/recent-order' || location.pathname === '/mybooking') ? <img src={trashicon} alt='car-img' data-tooltip-id="cancel-order" className='trash-icon-mob' /> : null} */}
        </div>
      </div>
      <CarOwnerDetailsModal
        data={data}
        open={isCarOwnerModalOpen}
        handleClose={handleCloseModal}
      />
    </div>
  );
};

export default BookingCard;
